import { render, staticRenderFns } from "./doc_updown.vue?vue&type=template&id=65a5d492&scoped=true"
import script from "./doc_updown.vue?vue&type=script&lang=js"
export * from "./doc_updown.vue?vue&type=script&lang=js"
import style0 from "./doc_updown.vue?vue&type=style&index=0&id=65a5d492&prod&lang=css"
import style1 from "./doc_updown.vue?vue&type=style&index=1&id=65a5d492&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5d492",
  null
  
)

export default component.exports